import React, { useRef } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { useThemeContext } from '../../app/theme-provider';
import { Button } from '../button';

import styles from './explanation.module.scss';

interface ExplanationProps {
  information: string;
  titleLabel: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export function Explanation({
  information,
  titleLabel,
  isOpen,
  setIsOpen,
}: ExplanationProps) {
  const { theme } = useThemeContext();
  const toggle = () => setIsOpen(!isOpen);
  const focusRef = useRef<HTMLDivElement>(null);

  return (
    <Modal
      data-bs-theme={theme}
      centered
      toggle={() => toggle()}
      isOpen={isOpen}
      onOpened={() => {
        if (focusRef.current) {
          focusRef.current?.focus();
        }
      }}
    >
      <ModalHeader tag="div" className={styles.card}>
        <h1 className="h6" ref={focusRef} tabIndex={0}>
          <p className="mb-1">Explanation for</p>
          <span className={`${styles.headerText} d-block ms-1`}>
            {titleLabel}
          </span>
        </h1>
      </ModalHeader>
      <ModalBody className={styles.card} tabIndex={0}>
        {information}
      </ModalBody>
      <ModalFooter className={styles.card}>
        <Button
          onClick={() => toggle()}
          aria-label="Close"
          color="primary"
          className="me-3"
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}
